/**
 * Gated consulting-report download form.
 * POSTs JSON as text/plain (avoids CORS preflight) to Apps Script Web App.
 */ (function() {
    function t(key) {
        var pack = typeof dafaultLanguage !== "undefined" && dafaultLanguage.reportDownload || {};
        var entry = pack[key];
        if (!entry) return key;
        var lang = typeof getPreferredLang === "function" && getPreferredLang() || document.documentElement.lang || "ja";
        return entry[lang] || entry.ja || key;
    }
    function setStatus(el, message, kind) {
        if (!el) return;
        el.hidden = !message;
        el.textContent = message || "";
        el.classList.remove("report-gate__status--ok", "report-gate__status--err");
        if (kind === "ok") el.classList.add("report-gate__status--ok");
        if (kind === "err") el.classList.add("report-gate__status--err");
    }
    function triggerDownload(url) {
        var a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
    async function submitForm(form) {
        var statusEl = form.querySelector("[data-report-gate-status]");
        var submitBtn = form.querySelector(".report-gate__submit");
        var fd = new FormData(form);
        var config = typeof REPORT_DOWNLOAD_CONFIG !== "undefined" ? REPORT_DOWNLOAD_CONFIG : {};
        var endpoint = (config.reportEndpoints || {})[String(fd.get("reportId") || "").trim()] || config.endpointUrl || "";
        if (!endpoint) {
            setStatus(statusEl, t("notConfigured"), "err");
            return;
        }
        var consent = form.querySelector("[name='consent']");
        if (!consent || !consent.checked) {
            setStatus(statusEl, t("consentRequired"), "err");
            return;
        }
        var payload = {
            name: String(fd.get("name") || "").trim(),
            company: String(fd.get("company") || "").trim(),
            email: String(fd.get("email") || "").trim(),
            reportId: String(fd.get("reportId") || "").trim(),
            reportTitle: String(fd.get("reportTitle") || "").trim(),
            consent: true,
            lang: typeof getPreferredLang === "function" && getPreferredLang() || "ja",
            userAgent: navigator.userAgent || ""
        };
        if (!payload.name || !payload.company || !payload.email || !payload.reportId) {
            setStatus(statusEl, t("missingFields"), "err");
            return;
        }
        if (submitBtn) submitBtn.disabled = true;
        setStatus(statusEl, t("submitting"), null);
        try {
            var res = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "text/plain;charset=utf-8"
                },
                body: JSON.stringify(payload),
                redirect: "follow"
            });
            var text = await res.text();
            var data;
            try {
                data = JSON.parse(text);
            } catch (parseErr) {
                setStatus(statusEl, t("failed"), "err");
                return;
            }
            if (!data || !data.ok || !data.downloadUrl) {
                var errKey = data && data.error || "failed";
                var known = {
                    consent_required: t("consentRequired"),
                    missing_fields: t("missingFields"),
                    invalid_email: t("invalidEmail"),
                    unknown_report: t("notConfigured"),
                    sheet_not_configured: t("notConfigured"),
                    sheet_missing: t("notConfigured"),
                    server_error: t("failed")
                };
                setStatus(statusEl, known[errKey] || t("failed"), "err");
                return;
            }
            setStatus(statusEl, t("success"), "ok");
            triggerDownload(data.downloadUrl);
            form.reset();
        } catch (err) {
            setStatus(statusEl, t("failed"), "err");
        } finally{
            if (submitBtn) submitBtn.disabled = false;
        }
    }
    function bindReportGateForms() {
        document.querySelectorAll("[data-report-gate-form]").forEach(function(form) {
            if (form.dataset.bound === "1") return;
            form.dataset.bound = "1";
            form.addEventListener("submit", function(ev) {
                ev.preventDefault();
                submitForm(form);
            });
        });
    }
    function applyReportGateI18n() {
        document.querySelectorAll("[data-i18n-report]").forEach(function(el) {
            var key = el.getAttribute("data-i18n-report");
            if (key) el.textContent = t(key);
        });
        document.querySelectorAll("[data-i18n-report-placeholder]").forEach(function(el) {
            var key = el.getAttribute("data-i18n-report-placeholder");
            if (key) el.setAttribute("placeholder", t(key));
        });
    }
    window.bindReportGateForms = bindReportGateForms;
    window.applyReportGateI18n = applyReportGateI18n;
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function() {
        applyReportGateI18n();
        bindReportGateForms();
    });
    else {
        applyReportGateI18n();
        bindReportGateForms();
    }
})();

//# sourceMappingURL=drone-report-2026.5fb145de.js.map
